import styled from "styled-components";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

type ReportTableProps = {
  onRowClick: (id: string) => void;
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
  data: [];
};

const columns = [
  {
    path: "merchant_name",
    label: "Merchant Name",
  },
  {
    path: "merchant_id",
    label: "Merchant ID",
  },
  {
    path: "onboard_date",
    label: "Onboard Date",
  },
];

const ReportTable = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
  onRowClick,
}: ReportTableProps) => {
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          onRowClick={onRowClick}
        />
      </TableWrapper>

      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Report Details"}
          onRowClick={onRowClick}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;
const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default ReportTable;
